// Reusable building blocks for selectable/bulk-deletable tables.
import React from 'react';
import { Trash2, X } from 'lucide-react';

export const useSelection = () => {
  const [selected, setSelected] = React.useState(new Set());
  const toggle = (id) => {
    setSelected((prev) => {
      const n = new Set(prev);
      // eslint-disable-next-line no-unused-expressions
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  };
  const toggleAll = (ids) => {
    setSelected((prev) => {
      const allSet = ids.every((id) => prev.has(id));
      return allSet ? new Set() : new Set(ids);
    });
  };
  const clear = () => setSelected(new Set());
  const has = (id) => selected.has(id);
  return { selected, toggle, toggleAll, clear, has, count: selected.size };
};

export const SelectionCheckbox = ({ checked, onChange, testid, label }) => (
  <label className="inline-flex items-center cursor-pointer" onClick={(e) => e.stopPropagation()}>
    <input
      type="checkbox"
      checked={!!checked}
      onChange={onChange}
      data-testid={testid}
      aria-label={label || 'Select row'}
      className="h-4 w-4 rounded border-[#0B5E2A]/40 text-[#0B5E2A] focus:ring-2 focus:ring-[#0B5E2A]/30 accent-[#0B5E2A] cursor-pointer"
    />
  </label>
);

export const BulkActionBar = ({ count, onClear, onDelete, itemType, testid }) => {
  if (!count) return null;
  return (
    <div className="sticky top-0 z-20 mb-3 flex items-center justify-between gap-3 bg-[#0B5E2A] text-white rounded-lg px-4 py-2.5 shadow-md" data-testid={testid}>
      <div className="flex items-center gap-3">
        <button onClick={onClear} className="h-7 w-7 rounded-full bg-white/15 hover:bg-white/25 inline-flex items-center justify-center" title="Clear selection">
          <X className="h-3.5 w-3.5" />
        </button>
        <div className="text-sm font-semibold">
          {count} {count === 1 ? itemType : `${itemType}s`} selected
        </div>
      </div>
      <button onClick={onDelete} data-testid={`${testid}-delete`} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#F0B93C] text-[#06401d] hover:bg-[#e7a91f] text-sm font-bold transition-colors">
        <Trash2 className="h-3.5 w-3.5" /> Delete selected
      </button>
    </div>
  );
};
